export default {
    //加载百度地图
    load:function(){
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.src = "https://api.map.baidu.com/api?v=2.0&ak=7VOzdpruO5Pd33UdihdLMze5PTfR4huQ&callback=init";
        document.body.appendChild(script);
    },
    //加载谷歌地图
    // loadGoogle:function(){
    //     var script = document.createElement("script");
    //     script.type = "text/javascript";
    //     script.src = "https://ditu.google.cn/maps/api/js?sensor=true&key=AIzaSyBFWHdjksN7NVDtMEptcscTJ4MxvsgmjOE";
    //     document.body.appendChild(script);
    // }
}


// WEBPACK FOOTER //
// ./src/components/map.js